export const Stack = ({ children, style, id }) => {
    return (
        <div id={id} style={style} className='stack'>{children} </div>
    )
}